<template>
  <div :class="['footer', { 'big-z-index': showBrushVisible }]">
    <!-- 任务模式：左侧结束任务 -->
    <div v-if="taskMode" class="hover-content task-end" @click="handleTaskEnd">
      <img class="task-end-icon" :src="require('@/assets/common/task_end_icon.png')" alt="" />
      <span class="task-end-text">结束任务</span>
    </div>
    <!-- 普通模式：左侧返回 -->
    <div v-else class="hover-content" @click="getBack">
      <img class="left-icon" :src="require('@/assets/common/return-left.png')" alt="" />
    </div>

    <!-- 任务模式：右侧结束任务 -->
    <div v-if="taskMode" class="hover-content task-end right" @click="handleTaskEnd">
      <span class="task-end-text">结束任务</span>
      <img class="task-end-icon" :src="require('@/assets/common/task_end_icon.png')" alt="" />
    </div>
    <!-- 普通模式：右侧返回 -->
    <div v-else class="hover-content right" @click="getBack">
      <img class="left-icon" :src="require('@/assets/common/return-right.png')" alt="" />
    </div>

    <a-popover content="字体调整" overlay-class-name="popover-tips-text">
      <div class="hover-content font-size">
        <FontSize v-if="showSize" :font-size="size" @zoomChange="handleZoomChange" />
      </div>
    </a-popover>
    <slot name="custom" class="custom" />
  </div>
</template>

<script>
import FontSize from '@/components/common/FontSize'

export default {
  name: 'CommonFooter',
  components: {
    FontSize
  },
  props: {
    // 显示/隐藏 调整字体大小组件
    showSize: {
      type: Boolean,
      default: true
    },
    // 显示/隐藏 作答历史
    showHistory: {
      type: Boolean,
      default: () => false
    },
    // 退出拦截
    exitIntercept: {
      type: Boolean,
      default: () => false
    },
    // 任务模式：左右两侧显示"结束任务"按钮
    taskMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    size() {
      return Number(this.$store.getters.size)
    },
    showBrushVisible() {
      return this.$store.getters.showBrushVisible
    }
  },
  methods: {
    getBack() {
      if (this.exitIntercept) {
        this.$emit('goBack')
      } else {
        this.$router.back()
      }
    },
    handleZoomChange(value) {
      this.$emit('zoomChange', value)
    },
    handleTaskEnd() {
      this.$emit('taskEnd')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: calc(100% - 2px);
  height: 64px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #ffffff;
  border-top: 1px solid #eeeeee;
  user-select: none;
  box-shadow: 0 -5px 20px 0 rgba(0, 0, 0, 0.03);
  &.big-z-index {
    z-index: 10003;
  }

  .left-icon {
    width: 20px;
    height: 20px;
  }

  .task-end {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 16px;

    .task-end-icon {
      width: 20px;
      height: 20px;
    }

    .task-end-text {
      font-size: 15px;
      font-weight: 400;
      color: #333333;
      white-space: nowrap;
      margin-left: 6px;
    }
  }

  .text {
    font-size: 17px;
    font-weight: 600;
    color: #333333;
    margin-left: 5px;
  }

  .font-size {
    padding: 0;
  }
  .custom {
    width: calc(100% - 120px);
  }
}
</style>
